
import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Vision from './components/Vision';
import Curriculum from './components/Curriculum';
import Recruitment from './components/Recruitment';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { ApplicationModal, PolicyModal } from './components/Modals';
import { ModalType } from './types';
import { AnimatePresence } from 'framer-motion';

const App: React.FC = () => {
  const [activeModal, setActiveModal] = useState<ModalType>(null);

  const openApply = () => setActiveModal('apply');
  const openPolicy = (type: 'privacy' | 'terms') => setActiveModal(type);
  const closeModals = () => setActiveModal(null);

  return (
    <div className="min-h-screen selection:bg-[#FFC222] selection:text-black">
      <Header onApplyClick={openApply} />
      
      <main>
        <Hero />
        <Vision />
        <Curriculum />
        <Recruitment />
        <FAQ />
        <CTASection onApplyClick={openApply} />
      </main>

      <Footer onLinkClick={openPolicy} />

      <AnimatePresence>
        {activeModal === 'apply' && (
          <ApplicationModal 
            isOpen={true} 
            onClose={closeModals} 
          />
        )}
        {(activeModal === 'privacy' || activeModal === 'terms') && (
          <PolicyModal 
            type={activeModal} 
            onClose={closeModals} 
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default App;
